import { useEffect, useRef } from 'react'

export const useUpdateEffect: typeof useEffect = (effect, deps) => {
	const isMounted = useRef(false)

	// biome-ignore lint/correctness/useExhaustiveDependencies: Deps are defined as params
	useEffect(() => {
		let cleanup: ReturnType<typeof effect>
		if (isMounted.current) {
			cleanup = effect()
		} else {
			isMounted.current = true
		}
		return () => {
			cleanup?.()
		}
	}, deps)
}
